import React from 'react';
import { Shield, Zap, Mail } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function ProductHero() {
  return <div className="my-12 border border-[#E5E5E0] bg-[#F9F7F4] p-6 md:p-8 rounded-sm relative" data-id="element-249">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#1a1a1a] text-white text-[10px] font-bold uppercase tracking-widest px-3 py-1 font-sans" data-id="element-250">
        Editor's Pick
      </div>

      <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-251">
        <div className="w-full md:w-1/3 bg-white p-4 border border-[#E5E5E0] shadow-sm" data-id="element-252">
          <img src="https://cdn.magicpatterns.com/uploads/dhFEgYBjJoWDrrEjUjNWsZ/mock_up_english.png" alt="The Knee Geometry Method" className="w-full h-auto object-cover" data-id="element-253" />
        </div>

        <div className="w-full md:w-2/3 text-center md:text-left" data-id="element-254">
          <h3 className="text-[20px] font-bold text-[#1a1a1a] font-serif mb-2" data-id="element-255">
            The Knee Geometry Method — 15-Day Plan
          </h3>
          <p className="text-[14px] text-[#666] mb-4 font-sans" data-id="element-256">
            A comprehensive digital guide to rebuilding knee confidence at home.
          </p>

          <div className="flex items-baseline justify-center md:justify-start gap-3 mb-6" data-id="element-257">
            <span className="text-[14px] text-[#888] line-through font-sans" data-id="element-258">
              $19.99
            </span>
            <span className="text-[24px] font-bold text-[#8B2500] font-sans" data-id="element-259">
              $6.99 USD
            </span>
          </div>

          <a href="#get-the-method" className="inline-block w-full md:w-auto bg-[#8B2500] text-white font-sans font-bold text-[14px] uppercase tracking-wide px-8 py-3 rounded-sm hover:bg-[#6d1d00] transition-colors text-center no-underline" data-id="element-260">
            Get the Guide — $6.99
          </a>

          <div className="flex items-center justify-center md:justify-start gap-4 mt-4 text-[10px] text-[#666] font-sans uppercase tracking-wide" data-id="element-261">
            <div className="flex items-center gap-1" data-id="element-262">
              <Shield size={12} data-id="element-263" /> Secure
            </div>
            <div className="flex items-center gap-1" data-id="element-264">
              <Zap size={12} data-id="element-265" /> Instant
            </div>
            <div className="flex items-center gap-1" data-id="element-266">
              <Mail size={12} data-id="element-267" /> Email Delivery
            </div>
          </div>
        </div>
      </div>
    </div>;
}